import Vue from 'vue';

import UserWindowSizeUtility from '@/classes/common/UserWindowSizeUtility';



/** 通常背景色 */
const BG_COLOR = 'rgba(234, 234, 234, 1)';

/** フォーカス背景色 */
const FOCUS_COLOR = 'rgba(192, 255, 192, 1)';

/** 筆跡色 */
const PEN_COLOR = 'rgba(85, 85, 85, 1)';

export default Vue.extend({

  name: 'Calc1Confirm',

  props: {
    char: {
      type: String,
      default: ''
    },
    isFocus: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    canvas(): HTMLCanvasElement {
      const canvas = this.$refs.canvas;
      if (canvas === undefined) throw new Error('canvas未初期化');
      return canvas as HTMLCanvasElement;
    },
    canvasContext(): CanvasRenderingContext2D {
      const context = this.canvas.getContext('2d');
      if (context === null) throw new Error('context未初期化');
      return context;
    },
  },

  mounted(): void {
    this.$_setCanvasSize();
  },

  methods: {
    focus(): void {
      this.$emit('onClick');
    },
    onChangeWindowSizeHandler(): void {
      this.$_setCanvasSize();
    },
    $_setCanvasSize(): void {
      this.canvas.width = this.canvas.clientWidth;
      this.canvas.height = this.canvas.clientHeight;
      this.$_draw();
    },
    $_draw(): void {
      const context = this.canvasContext;
      context.font = UserWindowSizeUtility.canvasConfirmFont();

      // 塗りつぶし
      if (this.isFocus) context.fillStyle = FOCUS_COLOR;
      else              context.fillStyle = BG_COLOR;
      context.fillRect(0, 0, this.canvas.width, this.canvas.height);

      // 文字列がある場合は描画
      if (this.char !== '') {
        const textMetrics = context.measureText(this.char);
        const tw = textMetrics.width;
        const dy = UserWindowSizeUtility.calculateRatio(8);
        const x = (this.canvas.width - tw) / 2;
        const y = (this.canvas.height) / 2 + dy;
        context.fillStyle = PEN_COLOR;
        context.fillText(this.char, x, y);
      }
    }
  },

  watch: {
    char(): void {
      this.$_draw();
    },
    isFocus(): void {
      this.$_draw();
    }
  }

});
